import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import { getChallengePreviewImageUrl } from '../challengeUtils';

/**
 * Scorecard preview — display only (no download).
 * The scorecard image will appear automatically when shared
 * via Facebook or Messenger thanks to OG meta tags.
 */
export function ScorecardPreview({ 
  challengeCode, 
  scorecardKey, 
  isReady,
  hasError,
  onError
}) {
  const imageUrl = `${getChallengePreviewImageUrl(challengeCode)}?t=${scorecardKey}`;

  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-muted-foreground">Your Score Card:</p>
      <div className="relative rounded-lg overflow-hidden bg-muted/30 border min-h-[120px]">
        {!isReady ? (
          <div className="flex items-center justify-center h-[120px]">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2 text-sm text-muted-foreground">Generating score card...</span>
          </div>
        ) : hasError ? (
          <div className="flex flex-col items-center justify-center h-[120px] text-muted-foreground p-4">
            <AlertCircle className="h-8 w-8 mb-2" />
            <span className="text-sm text-center">Score card preview unavailable</span>
          </div>
        ) : (
          <img 
            key={scorecardKey}
            src={imageUrl}
            alt="Challenge Score Card" 
            className="w-full h-auto"
            data-testid="challenge-scorecard-preview"
            onError={onError}
          />
        )}
      </div>
    </div>
  );
}
